// Translations
import landing from '../views/landing/translations/tr'

// Translation: Login (Turkish)
export default Object.freeze({
	name: 'Giriş',
	views: { landing }
})
